<div class="modal-header">
	<h1 class="modal-title">Upload Proof</h1>
	<ae-modal-mover />
	<button
		class="btn btn-outline-dark"
		id="upload.proof.modal.component.close"
		title="Close"
		type="button"
		(click)="close()"
	>
		<i aria-hidden="true" class="far fa-times"></i>
	</button>
</div>
<div class="modal-body">
	<div class="alert alert-warning">
		Some of the updates entered require documentation proving that the change is
		correct. Please upload appropriate proof for each data value that requires
		it. Incorrect documentation could lead to your request taking longer to
		approve.
	</div>

	<div class="pb-4">
		<div class="fw-bold">Requirements</div>
		@for (field of originalFields; track field) {
			<div>
				@if (hasProof(field.id)) {
					<i
						aria-hidden="true"
						class="fas fa-file-circle-check text-success"
					></i>
				} @else {
					<i aria-hidden="true" class="fas fa-file-ban text-danger"></i>
				}
				{{ field.title }} - {{ field.description }}
			</div>
		}
	</div>

	<div *aeSpinWhile="loading">
		@for (ctrl of proofs.controls; track ctrl; let i = $index) {
			<div
				aeGroupValidation
				class="form-group force-display-feedback"
				[class.pt-2]="i !== 0"
				[formGroup]="ctrl"
			>
				<div>
					<div class="d-flex justify-content-between">
						<label for="upload.proof.modal.file.{{ i }}"
							>Upload and Attach Proof</label
						>
						@if (proofs?.length > 1) {
							<button
								class="btn btn-icon"
								id="upload.proof.modal.remove.{{ i }}"
								title="Remove File Upload Area"
								type="button"
								(click)="removeCtrl(i)"
							>
								<i aria-hidden="true" class="fas fa-times"></i>
							</button>
						}
					</div>

					<ae-file-uploader
						formControlName="file"
						id="upload.proof.modal.file.{{ i }}"
						[extensionsAllowed]="allowedExtensions"
					/>
					<ae-group-validation-display [maxDisplay]="1">
						<ng-template aeValidationError="required">
							File is required
						</ng-template>
					</ae-group-validation-display>
				</div>
				<div>
					<label
						class="screen-reader-text"
						for="upload.proof.modal.ids.{{ i }}"
					>
						Required Fields {{ i }}
					</label>
					<ng-select
						bindLabel="title"
						bindValue="id"
						formControlName="ids"
						id="upload.proof.modal.ids.{{ i }}"
						placeholder="Select the fields this proof applies to"
						[items]="fields"
						[multiple]="true"
					/>
					<ae-group-validation-display [maxDisplay]="1">
						<ng-template aeValidationError="required">
							Field is required
						</ng-template>
					</ae-group-validation-display>
				</div>
			</div>
		}

		@if (hasLastValue() && fields.length > 0) {
			<div class="text-center">
				<button
					class="btn btn-link"
					type="button"
					[disabled]="!hasLastValue() || allFieldsSelected() || loading"
					(click)="addProofControl()"
				>
					Add Another File
				</button>
			</div>
		}
	</div>
</div>
<div class="modal-footer">
	<button
		class="btn btn-default"
		id="upload.proof.modal.component.footer.close"
		type="button"
		(click)="close()"
	>
		Close
	</button>

	<button
		class="btn btn-primary"
		id="upload.proof.modal.component.footer.comments"
		type="button"
		[disabled]="!proofs?.valid || !allFieldsSelected()"
		(click)="upload()"
	>
		Upload and Update
	</button>
</div>
